import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {PopularCourseService} from '../../../shared/services/popular-course.service';

@Component({
    selector: 'app-popular-course-detail-shell',
    templateUrl: './popular-course-detail-shell.component.html',
    styleUrls: ['./popular-course-detail-shell.component.scss']
})
export class PopularCourseDetailShellComponent implements OnInit {
    public toggleMenu = false;
    public popularCourseId: any;
    popularCourse: any;

    constructor(private activatedRoute: ActivatedRoute,
                private router: Router,
                private popularCourseService: PopularCourseService) {
    }

    ngOnInit(): void {
        this.popularCourseId = this.activatedRoute.snapshot.params['id'];
        this.getPopularCourseDetail();
    }

    getPopularCourseDetail() {
        this.popularCourseService.detail(this.popularCourseId).subscribe(data => {
            if (data) {
                this.popularCourse = data;
            }
        });
    }

    goBack(): void {
        this.router.navigateByUrl('popular-courses');
    }
}
